module.exports = __webpack_public_path__ + "media/img/apple-touch-icon-ipad-2363a874d4bee65894d05cd1aa8d4b0f.png";